import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const CustomerUrl = `${Base_Url}/Customer`;

export const GetCustomerList = async (params) => {
  const res = await postApiWithAuthorization(
    `${CustomerUrl}/GetCustomerList`,
    params
  );
  return res;
};

export const AddUpdateCustomerApi = async (params) => {
  const res = await postApiWithAuthorization(
    `${CustomerUrl}/AddUpdateCustomer`,
    params
  );
  return res;
};
export const GetCustomerModel = async (CustomerKeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${CustomerUrl}/GetCustomerModel?adminKeyID=${adminKeyID}&CustomerKeyID=${CustomerKeyID}`
  );
  return res;
};

export const ChangeCustomerStatus = async (CustomerKeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${CustomerUrl}/ChangeCustomerStatus?adminKeyID=${adminKeyID}&CustomerKeyID=${CustomerKeyID}`
  );
  return res;
};

export const DeleteCustomer = async (CustomerKeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${CustomerUrl}/DeleteCustomer?adminKeyID=${adminKeyID}&CustomerKeyID=${CustomerKeyID}`
  );
  return res;
};
export const GetCustomerInformationModel = async (
  AdminKeyID,
  CustomerKeyID
) => {
  const res = await getApiWithAuthorization(
    `${CustomerUrl}/GetCustomerInformationModel?AdminKeyID=${AdminKeyID}&CustomerKeyID=${CustomerKeyID}`
  );
  return res;
};
